function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useState, useRef, useEffect, useContext } from 'react';
import cn from 'classnames';
import { string, bool } from 'prop-types';
import { AutocompleteContext } from '@immediate_media/component-config';
import Form from '../../organisms/Form';
import Button from '../Button';
import IconStack from '../IconStack';
import Icon from '../../atoms/Icon';
/**
 * SearchForm component.
 */

var _ref2 = /*#__PURE__*/React.createElement(Icon, {
  className: "search-form__search-icon",
  name: "search",
  color: "clickableRegular",
  size: 22
});

var _ref3 = /*#__PURE__*/React.createElement(IconStack, null, /*#__PURE__*/React.createElement(IconStack.Icon, {
  name: "cross",
  color: "baseWhite",
  size: 8
}), /*#__PURE__*/React.createElement(IconStack.Icon, {
  name: "circle",
  color: "backgroundExtraDark",
  size: 16
}));

var _ref4 = /*#__PURE__*/React.createElement(Form.Label, {
  className: "sr-only"
}, "Search");

var SearchForm = function SearchForm(_ref) {
  var className = _ref.className,
      url = _ref.url,
      inverted = _ref.inverted,
      mobileSquareBorders = _ref.mobileSquareBorders,
      placeholder = _ref.placeholder,
      query = _ref.query,
      inputId = _ref.inputId,
      focusInput = _ref.focusInput,
      isAutocomplete = _ref.isAutocomplete,
      restProps = _objectWithoutProperties(_ref, ["className", "url", "inverted", "mobileSquareBorders", "placeholder", "query", "inputId", "focusInput", "isAutocomplete"]);

  var formRef = useRef(null);
  var searchInputRef = useRef(null);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      showLoading = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      value = _useState4[0],
      setValue = _useState4[1];

  var autocomplete = useContext(AutocompleteContext);
  var defaultValue = '';
  useEffect(function () {
    // Note that iOS devices only want to show the keyboard on user-interaction to
    // an input element. The focus function will not cause the keyboard to show,
    // although it will cause the styling to change. Rather than hacking our
    // way around this we choose to just not trigger the event at all on iPad and iPhone
    if (focusInput) {
      if (typeof navigator !== 'undefined' && !navigator.userAgent.match(/iPad|iPhone/i)) {
        searchInputRef.current.focus();
      }
    }
  });
  useEffect(function () {
    var currentUrl = new URL(window.location.href);
    defaultValue = currentUrl.searchParams.get(query);
    searchInputRef.current.value = defaultValue;
    setValue(defaultValue);
  }, []);
  var prepend = _ref2;
  var append = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    className: 'search-form__reset-button' + (!value ? " search-form--hidden" : ""),
    inputAppend: true,
    ariaLabel: "Reset input",
    type: "reset",
    transparent: true,
    onClick: function onClick() {
      setValue('');
      searchInputRef.current.focus();
    }
  }, _ref3), /*#__PURE__*/React.createElement(Button, {
    className: "search-form__submit-button",
    inputAppend: true,
    icon: loading ? 'loading' : 'search',
    iconSpinning: loading,
    iconAnimationDuration: 750,
    iconSize: 24,
    ariaLabel: "Perform search",
    type: "submit",
    onClick: function onClick(evt) {
      evt.preventDefault();
      showLoading(true);
      formRef.current.submit();
    }
  }));

  var onChange = function onChange(e) {
    setValue(e.currentTarget.value);
  };

  return /*#__PURE__*/React.createElement(Form, {
    className: cn('search-form', className),
    action: url,
    inverted: inverted,
    mobileSquareBorders: mobileSquareBorders,
    role: "search",
    method: "GET",
    ref: formRef,
    "data-placement": restProps.dataPlacement,
    "data-component": "SearchForm"
  }, /*#__PURE__*/React.createElement(Form.Group, {
    inputId: inputId
  }, _ref4, /*#__PURE__*/React.createElement(Form.InputGroup, {
    className: "chromatic-ignore",
    defaultValue: defaultValue,
    placeholder: placeholder,
    name: query,
    autoComplete: "off",
    formInputRef: searchInputRef,
    prepend: prepend,
    append: append,
    onChange: onChange
  }, isAutocomplete && autocomplete ? /*#__PURE__*/React.createElement(Form.Autocomplete, {
    autocomplete: autocomplete,
    className: "form-autocomplete__group"
  }) : null)));
};

SearchForm.defaultProps = {
  className: null,
  url: null,
  inverted: null,
  mobileSquareBorders: false,
  placeholder: 'Search...',
  query: null,
  inputId: 'search-field',
  focusInput: false,
  isAutocomplete: false
};
SearchForm.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Additional class names to add to the component root. */
  className: string,

  /** The URL for the search. */
  url: Form.propTypes.action,

  /** Use the inverted form style. */
  inverted: Form.propTypes.inverted,

  /** Use to add 0 border radius to all input for tablet down break point. */
  mobileSquareBorders: bool,

  /** The placeholder for the search input. */
  placeholder: string,

  /** The query parameter used for the search. */
  query: string,

  /** An ID for the search input (defaults to "search-field"). */
  inputId: string,

  /** Focus input search field */
  focusInput: bool,

  /** Use the autocomplete search. */
  isAutocomplete: bool
} : {};
export default SearchForm;